// Copyright (c) 2020-2021, 2023 Visual Intelligence LP. All rights reserved.
//
export enum ExportInformationType {
  asset = 0,
  platform = 1,
  collection = 2,
  jobRequest = 3,
  deliverable = 4,
  customerUser = 5,
  staffUser = 6,
}

export const EXPORT_INFORMATION_TYPES_LABELS = {
  [ExportInformationType.asset]: 'Assets',
  [ExportInformationType.platform]: 'Platforms',
  [ExportInformationType.collection]: 'Collections',
  [ExportInformationType.jobRequest]: 'Job requests',
  [ExportInformationType.deliverable]: 'Deliverables',
  [ExportInformationType.customerUser]: 'Customer users',
  [ExportInformationType.staffUser]: 'Staff',
};

export enum ReportInformationType {
  collection = 0,
  process = 1,
  production = 2,
  //visuals = 3,
  //lidar = 4,
  //externals = 5,
  deliverables = 6,
  kml = 7,
  customerReport = 8
}

export const REPORT_INFORMATION_TYPES_LABELS = {
  [ReportInformationType.collection]: 'Collection',
  [ReportInformationType.process]: 'Process',
  [ReportInformationType.production]: 'Production',
  //[ReportInformationType.visuals]: 'Ground',
  //[ReportInformationType.lidar]: 'LiDAR',
  //[ReportInformationType.externals]: 'Externals',
  [ReportInformationType.deliverables]: 'Deliverables',
  [ReportInformationType.customerReport]: 'Customer report',
};

// Defs for import types.
// Note:This must match with the ImportFileType Enum in portal-api.
export enum ImportInformationType {
  asset = 1,
  platform = 2,
  customerUser = 3,
  staffUser = 4,
  jobRequest = 5,
  deliverable = 6,
  jobAssignment = 7,
  collection = 8,
  jobStatus = 9,
}

// Labels for import types.
export const IMPORT_INFORMATION_TYPES_LABELS = {
  [ImportInformationType.asset]: 'Assets',
  [ImportInformationType.platform]: 'Platforms',
  [ImportInformationType.customerUser]: 'Customer users',
  [ImportInformationType.staffUser]: 'Staff',
  [ImportInformationType.jobRequest]: 'Job requests',
  [ImportInformationType.deliverable]: 'Deliverables',
  [ImportInformationType.jobAssignment]: 'Job assignments',
  [ImportInformationType.collection]: 'Collections',
  [ImportInformationType.jobStatus]: 'Job status',
};